export class EntityTypeBase {

	id!: number
	name!: string
	code!: string

	static from(entityType: EntityType): EntityTypeBase {
		let current = new EntityTypeBase()
		Object.assign(current, entityType)

		return current
	}
}

export interface EntityType extends EntityTypeBase {

}
